import { render, staticRenderFns } from "./CostsPage.vue?vue&type=template&id=9d180394"
import script from "./CostsPage.vue?vue&type=script&lang=ts"
export * from "./CostsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports